import { gql } from '@apollo/client';
import { JOB_APPLICATION_FIELDS } from '../../fragments';
import { CreateJobApplicationProps } from './jobApplication.types';
import { JobApplicationType } from '../../../types';
import { GET_JOB_APPLICATIONS } from '../../queries';

export const CREATE_JOB_APPLICATION = gql`
  ${JOB_APPLICATION_FIELDS}
  mutation CreateJobApplication(
  $firstName: String!
  $middleName: String
  $lastName: String!
  $dateOfBirth: String!
  $gender: String!
  $registrationNumber: String!
  $phone1: String!
  $phone2: String
  $email: String!
  $addressLine1: String!
  $addressLine2: String
  $city: String!
  $postalCode: String
  $country: String!
  $jobId: ID!
  ) {
    createJobApplication(
    firstName: $firstName
    middleName: $middleName
    lastName: $lastName
    dateOfBirth: $dateOfBirth
    gender: $gender
    registrationNumber: $registrationNumber
    phone1: $phone1
    phone2: $phone2
    email: $email
    addressLine1: $addressLine1
    addressLine2: $addressLine2
    city: $city
    postalCode: $postalCode
    country: $country
    jobId: $jobId
    ) {
      ...JobApplicationFields
    }
  }
`;

export function createJobApplication({
  client,
  firstName,
  middleName,
  lastName,
  dateOfBirth,
  gender,
  registrationNumber,
  phone1,
  phone2,
  email,
  addressLine1,
  addressLine2,
  city,
  postalCode,
  country,
  jobId,
}: CreateJobApplicationProps) {
  return client?.mutate<{ createJobApplication: JobApplicationType }>({
    mutation: CREATE_JOB_APPLICATION,
    variables: {
      firstName,
      middleName,
      lastName,
      dateOfBirth,
      gender,
      registrationNumber,
      phone1,
      phone2,
      email,
      addressLine1,
      addressLine2,
      city,
      postalCode,
      country,
      jobId,
    },
    refetchQueries: [
      GET_JOB_APPLICATIONS,
    ],
  });
}
